
import Component from 'vue-class-component';

// The base for every interactive modal
import InteractiveModalBase from './internals/InteractiveBase.vue';

// Modal types
import { ModalType } from './types';

/**
 *  Used to provide information to the user using a modal.
 */
@Component
export default class InfoModal extends InteractiveModalBase {

    protected type = ModalType.Info;

}
